import type { PaginationResponse, UserRoles } from 'core/base';
import { BaseRepository } from 'core/base';
import type { AxiosRequestConfig } from 'axios';
import type { UserModel } from './User.model';
import type { UserId } from '../../types';
import type { RoleModel } from './Role.model';

export class UsersRepository extends BaseRepository {
  constructor() {
    super('/users');
  }

  async getAll(config?: AxiosRequestConfig) {
    const { data } = await this.httpClient.get<PaginationResponse<UserModel>>('/', config);

    return data;
  }

  async getUserInfo() {
    const { data } = await this.httpClient.get<UserModel>('/me');

    return data;
  }

  getRoles() {
    return this.httpClient.get<RoleModel[]>('/roles').then(({ data }) => data);
  }

  updateUserRoles(id: UserId, roles: UserRoles[]) {
    return this.httpClient.put<void>(`/${id}/roles`, roles).then(({ data }) => data);
  }

  updateManyUsersRoles(usersForUpdate: { userID: UserId; roles: UserRoles[] }[]) {
    return this.httpClient.post<void>(`/update/roles`, usersForUpdate).then(({ data }) => data);
  }
}
